import React, { useState, useRef, useEffect } from 'react';
import { injectIntl } from 'react-intl';

import { CreateButton, MainButton } from './ActionButton';
import ActionLink from './ActionLink';
import ConfirmButton from './ConfirmButton';
import Loader from './Loader';

const SaveButton = (props) => {
	const [ saving, setSaving ] = useState(false);
	const [ error, setError ] = useState(props?.error ?? false);

	const unmounted = useRef(false);
	const t = useRef(null);
	const t2 = useRef(null);

	useEffect(() => {
		setError(props?.error ?? false);
	}, [props.error]);

	const finished = (successful, msg, cb) => {
		if(successful === false) {
			setError(msg);
			setSaving(false);

			t2.current = setTimeout(() => {
				setError(false);
			}, 2000);
			return;
		}

		if(unmounted.current) return;

		t.current = setTimeout(() => {
			setSaving(false);
			if(cb != undefined) cb();
		}, (props?.time ?? 1000));
	};

	useEffect(() => {
		return () => {
			unmounted.current = true;
			if(t.current != undefined) clearInterval(t.current);
			if(t2.current != undefined) clearInterval(t2.current);
		}
	}, []);

	const initLoading = () => {
		setSaving(true);
	};

	const onclick = (e) => {
		initLoading();
	
		//Delay per evitar bloquejos en processos costosos com pujar fitxers grans
		setTimeout(()=>{
			if(props.onClick != undefined) props.onClick(e, finished);
		}, 300);
	};

	const ontouchstart = (e) => {
		initLoading();
		if(props.onTouchStart != undefined) props.onTouchStart(e, finished);
	};

	const ontouchend = (e) => {
		initLoading();
		if(props.onTouchEnd != undefined) props.onTouchEnd(e, finished);
	};

	const onmouseup = (e) => {
		initLoading();
		if(props.onMouseUp != undefined) props.onMouseUp(e, finished);
	};

	const _props = Object.assign({}, {...props}, { onClick:onclick });
	if(props?.enable_mobile_events ?? false) {
		if(props.onTouchStart != undefined) _props.onTouchStart = ontouchstart;
		if(props.onTouchEnd != undefined) _props.onTouchEnd = ontouchend;
		if(props.onMouseUp != undefined) _props.onMouseUp = onmouseup;
	}
	let props_saving = { ...props, color:'gray', _class:{...props._class, other:'is_processing' + ((props._class != undefined && props._class.other != undefined) ? ' ' + props._class.other : '')}};
	props_saving.onClick = null;
	props_saving.autotranslate = false;

	const props_error  = {...props, color:'red', _class:{...props._class, icon:'knk-alert', other:'is_error'}};

	let Component = MainButton;
	if(props.type != undefined) {
		switch(props.type) {
			case 'confirm':
				Component = ConfirmButton;
				break;

			case 'link':
				Component = ActionLink;
				break;

			case 'create':
				Component = CreateButton;
				break;
		}
	}

	if(error !== false) {
		return (
			<div class="in_top gui_pos_rel">
				{(error) && (
					<aside class="error_report">{props.intl.formatMessage({id:error})}</aside>
				)}

				<Component
					{...props_error}
				>Error</Component>
			</div>
		)
	}

	if(saving) {
		return (
			<Component
				{...props_saving}
				icon={false}
			>&nbsp;<Loader /></Component>
		)
	}

	return (
		<Component
			{..._props}
		>{props.children}</Component>
	)
}

export default injectIntl(SaveButton);